export const chevronUp = {
  name: "chevron-up" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.864 16.136a.9.9 0 0 0 1.272 0L12 9.273l6.864 6.863a.9.9 0 0 0 1.272-1.272l-7.5-7.5a.9.9 0 0 0-1.272 0l-7.5 7.5a.9.9 0 0 0 0 1.272Z" clip-rule="evenodd"/></svg>`,
  keywords: ["chevron-up"],
  category: "utility" as const,
};
